import { qsPost } from './axios';

// login
export const userLogin = data => qsPost('https://utp.veryengine.cn/User/Login', data);

export const manMachine = data => qsPost('https://utp.veryengine.cn/User/manMachine', data);

export const BindPersonTag = (data) => qsPost('https://utp.veryengine.cn/Tag/BindPersonTag', data);

export const queryPersonTag = (data) => qsPost('https://utp.veryengine.cn/Tag/queryPersonTag', data);

export const currentSoftware = (data) => qsPost('https://utp.veryengine.cn/Tag/CurrentSoftware',data)

export const hasLogin = data => qsPost('https://utp.veryengine.cn/User/HasLogin', data);

export const signout = () => qsPost('https://utp.veryengine.cn/User/SignOut');

export const modelQuery = (data) => qsPost('https://assetstore.veryengine.cn/query', data);

export const modelImport = (data) => qsPost('https://assetstore.veryengine.cn/expo/export', data);
